<template>
    <div v-if="userAttribute != null">
        <template>
            <div class="object-titlebox">
                <!-- タイトル -->
                <div class="object-titlebox-left" v-t="'message.title_call_user_information'"></div>
                <div class="object-titlebox-right">
                    <!-- 強制ログアウトボタン -->
                    <button class="transparent-button" type="button" v-on:click="forceLogoutConfirmUser()">
                        <img src="../../assets/icon_force_logout.svg" />
                        <span class="important-command-text" v-t="'message.action_force_logout'"></span>
                    </button>
                    <!-- 削除ボタン -->
                    <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('DeleteUser')">
                        <img src="../../assets/delete.svg" />
                        <span class="important-command-text" v-t="'message.common_action_delete'"></span>
                    </button>

                    <!-- 移動ボタン -->
                    <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('MoveUser')">
                        <img src="../../assets/move.svg"/>
                        <span class="normal-command-text" v-t="'message.common_action_move'"></span>
                    </button>

                    <!-- 編集ボタン -->
                    <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('EditUser')">
                        <img src="../../assets/edit.svg" /><span class="normal-command-text" v-t="'message.common_action_edit'"></span>
                    </button>
                </div>
            </div>
            <table width=100%>
                <!-- ユーザーID -->
                <tr class="objectitem-record">
                    <td class="object-item" v-t="'message.item_userId'"></td>
                    <td class="object-value">{{ userAttribute.name }}</td>
                </tr>
                <!-- ログインID -->
                <tr class="objectitem-record">
                    <td class="object-item" v-t="'message.item_login_id'"></td>
                    <td class="object-value">{{ userAttribute.name }}@{{ appData.tenantList[0].name }}</td>
                </tr>
                <!-- ユーザー表示名 -->
                <tr class="objectitem-record">
                    <td class="object-item" width=50% v-t="'message.item_userDisplayName'"></td>
                    <td class="object-value">{{ userAttribute.displayName }}</td>
                </tr>
                <!-- 通知先グループ -->
                <tr class="objectitem-record">
                    <td class="object-item" width=50% v-t="'message.item_target_group'"></td>
                    <td class="object-value">{{ userAttribute.talkGroup.talkgroupName }}</td>
                </tr>
                <!-- タイムアウト -->
                <tr class="objectitem-record">
                    <td width=50% class="object-item" v-t="'message.item_option_buddycomCall_request_time_out'"></td>
                    <td class="object-value">{{ userAttribute.requestTimeOut }}</td>
                </tr>
                <!-- 音声案内 -->
                <tr class="objectitem-record">
                    <td width=50% class="object-item" v-t="'message.item_option_buddycomCall_idling_voice'"></td>
                    <td v-if="userAttribute.idlingVoiceEnabled" class="object-value" v-t="'message.item_value_used'"></td>
                        <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                </tr>
                <!-- 音声案内内容 -->
                 <tr class="objectitem-record">
                    <td width=50% class="object-item" v-t="'message.item_option_buddycomCall_idling_voice_value'"></td>
                    <td v-if="userAttribute.idlingVoiceEnabled" class="object-value">{{ userAttribute.idlingText }}</td>
                </tr>
            </table>
        </template>

        <force-logout v-if="showForceLogoutUser" :confirmInfo="confirmInfo" @logout="forceLogoutUser" @cancel="showForceLogoutUser=false"></force-logout>
        <deleteuser v-if="showDeleteUser" :confirmInfo="confirmInfo" @delete="deleteUser" @cancel="showDeleteUser=false"></deleteuser>
        <moveuser v-if="showMoveUser" :appData="appData" @move="moveUser" :sourceObjectId="userAttribute.id" @cancel="showMoveUser=false"></moveuser>
        <edituser v-if="showEditUser" :appData="appData" :userAttribute="userAttribute" @save="editUser" @cancel="showEditUser=false"></edituser>
    </div>
</template>


<script>
import server from "../ServerApi.js"
import ForceLogout from "../ForceLogout.vue";
import DeleteObject from "../DeleteObject.vue"
import MoveUser from "../MoveObject.vue";
import EditBuddycomCallUser from "./EditBuddycomCallUser.vue"
import commonUtil from '../commonutil.js'
import constants from '../constants.js'

export default {
    components: {
        forceLogout: ForceLogout,
        deleteuser: DeleteObject,
        moveuser: MoveUser,
        edituser: EditBuddycomCallUser,
    },

    props: {
        selectedNode: Object,
        appData: Object
    },

    data() {
        return {
            MAX_USER_TALKGROUP_COUNT: 500,
            userAttribute: null,
            showDeleteUser: false,
            showForceLogoutUser: false,
            showMoveUser: false,
            showEditUser: false,
            confirmInfo: {
                objectName: null,
                objectTitle: null
            },
        };
    },

    watch: {
        selectedNode: {
            handler() {
                return this.getInfo();
            }
        }
    },

    // ライフサイクル
    created() {
        return this.getInfo();
    },

    methods: {
        showLoadingScreen() {
            if (this.loadingScreen == null) {
                this.loadingScreen = this.$loading({
                        lock: true ,
                        text: 'Loading data ...' ,
                        spinner: 'el-icon-loading' ,
                        background: 'rgba(0, 0, 0, 0)'
                });
            }
        },

        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },

        getInfo() {
            if (this.selectedNode == null) {
                return;
            }
            let self = this;
            this.searchString = null;
            this.userAttribute = null;
            if (this.talkGroupUsers != null) {
                this.talkGroupUsers.splice(0, this.talkGroupUsers.length)
            }

            this.showLoadingScreen();

            server.post('/getinfo', { tenantId: this.appData.tenantList[0].tenantId, id: this.selectedNode.node.data.id, maxUserTalkgroupCount: this.MAX_USER_TALKGROUP_COUNT })
                .then((res) => {
                    self.closeLoadingScreen();

                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (self.selectedNode.node.parent.data.id != res.data.pid) {
                                self.nodeInfo = null;
                                commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_already_moved").replace("{object}", commonUtil.getMessageText(self.$i18n, "item_user")))
                                self.$emit('refresh');
                                return;
                            }
                            break
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            self.usersTalkgroupCount = res.data.talkgroups.length
                            self.usersTalkGroupExceededMax = true
                            break
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_not_have_read_permission_on_layer").replace("{object}", commonUtil.getMessageText(self.$i18n, "item_user")))
                            self.$emit('refresh')
                            return
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_already_deleted").replace("{object}", commonUtil.getMessageText(self.$i18n, "item_user")))
                            self.$emit('resetSelectedNode')
                            self.$emit('refresh')
                            return
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "getInfo").replace("{code}", res.data.status))
                            return
                    }
                    self.userAttribute = res.data
                    self.isAdminUser = self.userAttribute.restrictions != null && self.userAttribute.restrictions.includes(constants.RESTRICTION_LOGIN)
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "getInfo", error)
                    self.loadingScreen.close();
                })
        },

        showDialogAfterWritableCheck(functionName) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }

            if (functionName == 'DeleteUser') {
                if (this.userAttribute.rights != null && this.userAttribute.rights.indexOf('tenantadmin') >= 0) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_user_tenant_admin"))
                    return
                }
            }

            let self = this
            server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, id: this.selectedNode.node.parent.data.id })
                .then((res) => {
                    if(res.data.status == constants.STATUS_SUCCESS) {
                        let myAclId = self.appData.tenantList[0].tenantId + "-" + self.appData.loginUserObjectId
                        let acl = JSON.parse(res.data.acl)
                        if (acl.rw != null) {
                            let writable = acl.rw.find(function(element) {
                                return element == myAclId
                            });
                            if (writable == null) {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")))
                            } else {
                                switch(functionName) {
                                    case "EditUser":
                                        self.showEditUser = true
                                        break
                                    case "DeleteUser":
                                        self.deleteConfirmUser()
                                        break
                                    case "MoveUser":
                                        self.showMoveUser = true
                                        break
                                }
                            }
                        } else {
                            // no writable acl info
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_access_denied"))
                        }
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","showDialogAfterWritableCheck").replace("{code}",res.data.status))
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "showDialogAfterWritableCheck", error)
                });
        },

        forceLogoutConfirmUser: function() {
            this.confirmInfo.objectType = constants.OBJECT_BUDDYCOM_CALL_USER
            this.confirmInfo.objectName = this.userAttribute.displayName
            this.showForceLogoutUser = true
        },

        forceLogoutUser: function() {
            this.showForceLogoutUser = false
            let self = this

            server.post(
                '/forcelogoutbuddycomcalluser',
                {
                    id: self.selectedNode.node.data.id,
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_force_logout_completed"));
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_NOT_FOUND:
                        case constants.STATUS_ERROR_TALKGROUP_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_logout"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","forceLogoutUser").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "forceLogoutUser", error);
            });
        },

        deleteConfirmUser: function() {
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"item_user")
            this.confirmInfo.objectName = this.userAttribute.displayName
            this.showDeleteUser = true
        },

        deleteUser: function() {
            this.showDeleteUser = false
            let self = this

            server.post(
                '/deletebuddycomcalluser',
                {
                    id: this.$data.userAttribute.id
                }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_user_delete_with_logout"))
                        if (this.listType == 0) {
                            self.selectedNode.node.parent.removeChild(self.selectedNode.node)
                        } else {
                            self.$emit('refresh')
                        }
                        self.$emit('resetSelectedNode')
                        break
                    case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_deleted_user"))
                        if (this.listType == 0) {
                            self.selectedNode.node.parent.removeChild(self.selectedNode.node)
                        } else {
                            self.$emit('refresh')
                        }
                        self.$emit('resetSelectedNode')
                        break
                    case constants.STATUS_ERROR_INVALID_PARAMETER :
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_user_root_admin"))
                        break
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")))
                        break
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_user_tenantLink_admin"))
                        break
                    case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")))
                        break
                    case constants.STATUS_ERROR_USER_HAS_EXPORTED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_user_joined_other_tenant").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")))
                        break
                    case constants.STATUS_ERROR_STILL_ASSIGNED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_group_exist_user"))
                        break
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","deleteUser").replace("{code}",res.data.status))
                        break
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "deleteUser", error)
            });
        },

        // 子viewからのパラメーターを受け取り更新処理
        editUser: function(input) {
            this.showEditUser = false

            const self = this

            // 編集前の値
            const before = this.userAttribute

            // 送信する値
            const payload = {
                id: before.id,
                parentId: before.parentId
            }

            let hasDiff = false

            // 各パラメーターの変更確認
            if (input.name !== before.name) {
                payload.name = input.name
                hasDiff = true
            }

            if (input.displayName !== before.displayName) {
                payload.displayName = input.displayName
                hasDiff = true
            }

            if (input.password && input.password !== '') {
                payload.password = input.password
                hasDiff = true
            }

            if (
                input.targetGroupId &&
                input.targetGroupId !== before.talkGroup?.talkGroupId
            ) {
                payload.beforeTalkGroupId = before.talkGroup?.talkGroupId
                hasDiff = true

                payload.talkGroupId = input.targetGroupId
                hasDiff = true
            }

            if (input.requestTimeOut !== before.requestTimeOut){
                payload.requestTimeOut = input.requestTimeOut
                hasDiff = true
            }

            if (input.idlingVoiceEnabled !== before.idlingVoiceEnabled){
                payload.idlingVoiceEnabled = input.idlingVoiceEnabled
                hasDiff = true
            }

            if (input.idlingText !== before.idlingText){
                payload.idlingText = input.idlingText
                hasDiff = true
            }

            if (!hasDiff) {
                commonUtil.notifyMessage(this, 'Info', this.$t('message.info_no_change_information'))
                return
            }

            server.post('/editbuddycomcalluser', payload)
            .then(res => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_user"))
                    if (self.selectedNode.node.data.label != input.name) {
                            var insertData = { data :
                                {
                                    tenantId: self.selectedNode.node.data.tenantId,
                                    id: self.selectedNode.node.data.id,
                                    label: input.name + " / " + input.displayName,
                                    type: constants.OBJECT_BUDDYCOM_CALL_USER,
                                    isLeaf: true
                                }
                            }
                        this.insertNewUserToTree(insertData, self.selectedNode.node.parent)
                        self.selectedNode.node.parent.removeChild(self.selectedNode.node)
                        self.getInfo()
                    } else {
                        self.$emit('refresh')
                    }
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")))
                            break
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_duplicateId"))
                            break
                        case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_insufficient_license"))
                            break
                        case constants.STATUS_ERROR_OPTION_UNMATCH:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_userOption"))
                            break
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")))
                            break
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","editBuddycomCallUser").replace("{code}",res.data.status))
                            break
                    }
                }
            })
            .catch(error => {
                commonUtil.putExceptionErrorMessage(self, 'editBuddycomCallUser', error)
            })
        },

        moveUser: function(destinationNodeId) {
            this.showMoveUser = false;
            let self = this;
            server.post(
                '/move',
                {
                    operation:
                    {
                        id: this.userAttribute.id ,
                        destinationId: destinationNodeId
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_moved_user"));
                    if (this.listType == 0) {
                        // this operation only performed when select the object from tree.
                        let parentNode = self.findNode(self.selectedNode.tree.$children[0].node , destinationNodeId);
                        if (parentNode != null) {
                            // parent node already loaded
                            var insertData = { data :
                                                {
                                                    tenantId: self.selectedNode.node.data.tenantId,
                                                    id: self.selectedNode.node.data.id,
                                                    label: self.selectedNode.node.data.label,
                                                    type: constants.OBJECT_BUDDYCOM_CALL_USER,
                                                    restrictions: self.selectedNode.node.data.restrictions,
                                                    isLeaf: true
                                                 }
                                             };
                            this.insertNewUserToTree(insertData, parentNode);
                        }
                        self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                    } else {
                        self.$emit('refresh');
                    }
                } else {
                    if ((res.data.status === constants.STATUS_ERROR_DENIED) && (self.isAdminUser)) {
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_move_consoleadmin_from_root"));
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","moveUser").replace("{code}",res.data.status));
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "moveUser", error);
            });
        },

        insertNewUserToTree(insertData , parentNode) {
            if (parentNode.childNodes.length == 0) {
                parentNode.insertChild(insertData,0)
                parentNode.expand()
                return
            }

            var insertIndex = this.getInsertIndexOfBuddycomCallUser(parentNode , insertData.data.label);
            if (insertIndex < 0) {
                parentNode.insertBefore(insertData,parentNode.childNodes[0])
            } else {
                parentNode.insertAfter(insertData,parentNode.childNodes[insertIndex])
            }
        },

        getInsertIndexOfBuddycomCallUser: function(parentNode , insertObjectName) {
            let insertIndex = -1;
            let lastIndex = -1;
            for (let i = 0; i < parentNode.childNodes.length; i++) {
                const node = parentNode.childNodes[i];
                const type = node.data.type;
                 if (type === constants.OBJECT_BUDDYCOM_CALL_USER) {
                    if (commonUtil.compareStringWithNumber(node.data.label, insertObjectName) <= 0) {
                        insertIndex = i;
                    }
                } else {
                    lastIndex = i;
                }
            }

            if (insertIndex == -1) {
                return Math.max(insertIndex, lastIndex);
            }

            return insertIndex;
        },
    }
}
</script>


<style scoped>
li {
    list-style: none;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
}

.modal-default-button {
    float: right;
}

input[type="radio"] {
    outline: 0;
    appearance: none;
    -webkit-appearance: none;
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(../../assets/icon_check_gray.svg);
}

input[type="radio"]:checked {
    outline: 0;
    width: 20px;
    height: 20px;
    background: url(../../assets/icon_check_green.svg);
}

input[type="radio"]:hover {
    cursor: pointer;
}

.talkgroup-title {
    width: 100%;
    padding: 10px 0 10px 28px;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}

.talkgroup-item-header1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}

.talkgroup-item-header2 {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 15%;
    text-align: center;
}

.talkgroup-item-record {
    border-bottom: 1px #eee solid;
}

.talkgroup-item-record:hover {
    background-color: #ecf1fa;
}

.talkgroup-item1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    font-size: 14px;
}

.talkgroup-item2 {
    text-align: center;
}

.el-select-dropdown__item {
    font-size: 12px;
}

.el-select-dropdown__item selected {
    color: #5171cb;
}

.custom-checkbox-input {
    display: none;
}

.action-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.el-tabs--border-card {
    box-shadow: none !important;
}

:deep(.el-tabs--border-card) .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}

:deep(.el-tabs--border-card).el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #f6f6f6;
    border: none;
}

:deep(.el-tabs--border-card) .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #ecf1fa;
}

.el-tabs__nav-scroll {
    background: #ecf1fa;
}

:deep(.el-tabs--border-card)el-tabs__header {
    border: none;
    background: #ecf1fa;
}

:deep(.el-tabs--border-card)el-tabs__content {
    padding: 0px;
}

.el-tabs--border-card {
    border: none;
}
</style>
